class StickySentinels {
  constructor() {
    this.header = document.querySelector('ci-header');
    this.content = document.querySelector('.pc-Subcategories-main-sections');
    this.sidebar = document.querySelector('.pc-Subcategories-section-content-left.is-sticky');
    this.crownSentinel = document.querySelector('.pc-Subcategories .crown-sentinel');
    this.lowerSentinel = document.querySelector('.pc-Subcategories-section-content-left.is-sticky .lower-sentinel');
    this.upperSentinel = document.querySelector('.pc-Subcategories-section-content-left.is-sticky .upper-sentinel');
    this.afterSentinel = document.querySelector('.pc-Subcategories .after-sentinel');
    this.observer = undefined;
    this.lastScrollTop = undefined;
    this.lastScrollDirection = undefined;
    this.initEventListeners();
  }

  // Private

  initEventListeners() {
    this.initObserver();

    this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.lastScrollDirection = 'down';

    window.addEventListener('scroll', () => this.handleScrollDirectionChange());
    window.addEventListener('resize', () => this.handleResize());
  }

  initObserver() {
    // Select the sidebar and the sentinels
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Set a flag as to whether the sidebar is overflowing the viewport
        const isOverflowing = this.sidebar.offsetHeight > window.innerHeight + 8;
        // Check which sentinel is intersecting and apply logic accordingly
        if (entry.target === this.lowerSentinel && isOverflowing && entry.isIntersecting && this.sidebar.style.position === 'sticky') {
          this.sidebar.style.position = 'relative';
          this.sidebar.style.top = `${this.content.offsetHeight - this.sidebar.offsetHeight - 56}px`;
        } else if (entry.target === this.lowerSentinel && entry.isIntersecting && this.sidebar.style.position !== 'sticky') {
          // Bottom of the sidebar (bottom-sentinel) has entered the viewport
          this.sidebar.style.position = 'sticky';
          this.sidebar.style.top = `${window.innerHeight - this.sidebar.offsetHeight - 16}px`;
        } else if (entry.target === this.upperSentinel && entry.isIntersecting && this.sidebar.style.position === 'relative') {
          // Top of the sidebar (top-sentinel) has entered the viewport
          this.sidebar.style.position = 'sticky';
          this.sidebar.style.top = '16px';
        } else if (entry.target === this.afterSentinel && isOverflowing && !entry.isIntersecting && this.sidebar.style.position === 'sticky') {
          // Content sentinel has left the viewport
          this.sidebar.style.position = 'relative';
          this.sidebar.style.top = `${this.content.offsetHeight - this.sidebar.offsetHeight - 56}px`;
        } else if (entry.target === this.crownSentinel && entry.isIntersecting) {
          // Crown sentinel (top of page) has entered the viewport
          this.sidebar.style.position = isOverflowing ? 'static' : 'sticky';
          this.sidebar.style.top = isOverflowing ? '' : '16px';
        }
      });
    }, {
      root: null, // Use the viewport as the root
      threshold: 0 // Trigger callback as soon as sentinel enters the viewport
    });

    this.observer.observe(this.crownSentinel);
    this.observer.observe(this.lowerSentinel);
    this.observer.observe(this.upperSentinel);
    this.observer.observe(this.afterSentinel);
  }

  handleScrollDirectionChange() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let currentScrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';

    // If direction changes and sidebar is sticky and sidebar is overflowing, change sidebar to relative
    if ((this.sidebar.offsetHeight > window.innerHeight + 8) && currentScrollDirection !== this.lastScrollDirection) {
      this.lastScrollDirection = currentScrollDirection;
      if (this.sidebar.style.position === 'sticky' && !(window.scrollY + window.innerHeight > this.content.offsetHeight + this.header.offsetHeight)) {
        this.sidebar.style.position = 'relative';
        if (currentScrollDirection === 'down') {
          this.sidebar.style.top = `${window.scrollY - this.header.offsetHeight}px`;
        } else {
          this.sidebar.style.top = `${window.scrollY - this.header.offsetHeight - this.sidebar.offsetHeight + window.innerHeight - 32}px`;
        }
      }
    }

    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Avoid negative scroll values
  }

  handleResize() {
    if ((this.sidebar.offsetHeight > window.innerHeight + 32) && this.sidebar.style.position !== 'sticky') {
      this.sidebar.style.position = 'sticky';
      this.sidebar.style.top = '16px';
    }
  }
}

jQuery(() => (ProductCatalog.StickySentinels = new StickySentinels()));
